module.exports = __webpack_public_path__ + "static/img/far2_active.70db1d6a.png";